//Util
import {
  MENSAGENS_ERRO,
  MENSAGENS_SUCESSO,
  showMensagemErro,
  showMensagemErroApi,
  showMensagemSucesso,
} from "../../utils/mensagens.jsx";

//API
import api from "./api.js";

/*
 * Lista as conexões com o banco de dados
 */
export async function api_listarConexoesBD() {
  let result;
  try {
    const { data } = await api.get(`/system/listarConexoesBD`);
    result = data;
  } catch (error) {
    if (error.response?.status != 401) {
      showMensagemErro(MENSAGENS_ERRO.CARREGAR, "conexões banco");
    }
  }
  return result;
}

/*
 * Finaliza as conexões inativas do banco de dados
 */
export async function api_finalizarConexoesBDInativas() {
  let result;
  try {
    const { data } = await api.get(`/system/finalizarConexoesBDInativas`);
    result = data;

    showMensagemSucesso(MENSAGENS_SUCESSO.OPERACAO_SUCESSO);
  } catch (error) {
    if (error.response?.status != 401) {
      showMensagemErro(
        MENSAGENS_ERRO.TENTATIVA_OPERACAO,
        "finalizar conexões inativas",
      );
    }
  }
  return result;
}

/*
 * Finaliza uma conexão específica com o banco
 */
export async function api_finalizarConexaoID(
  id,
  serial,
  conexao,
  motivo,
  idAutorizacao,
  idUsuarioAutorizacao,
) {
  let result;
  try {
    const { data } = await api.post(`/system/finalizarConexaoID`, {
      id,
      serial,
      conexao,
      motivo,
      id_autorizacao: idAutorizacao,
      id_usuario_autorizacao: idUsuarioAutorizacao,
    });
    result = data;

    showMensagemSucesso(MENSAGENS_SUCESSO.OPERACAO_SUCESSO);
  } catch (error) {
    if (error.response?.status != 401) {
      showMensagemErro(MENSAGENS_ERRO.TENTATIVA_OPERACAO, "finalizar conexão");
    }
  }
  return result;
}

/*
 * Lista os arquivos de log do servidor do tipo informado
 */
export async function api_listarArquivosLog(tipo) {
  let result = [];
  try {
    const { data } = await api.get(`/system/listarArquivosLog`, {
      params: { tipo },
    });
    result = data;
  } catch (error) {
    showMensagemErroApi(error, "listar os arquivos de log");
  }
  return result;
}

/*
 * Consulta os registros de um arquivo de log do servidor
 */
export async function api_consultarLog(tipo, arquivo, texto, limit) {
  let result;
  try {
    const { data } = await api.get(`/system/consultarLog`, {
      params: { tipo, arquivo, texto, limit },
    });
    result = data;
  } catch (error) {
    showMensagemErroApi(error, "consultar o log");
  }
  return result;
}

/*
 * Lista os usuários conectados de todos os clientes, com a hora em que o servidor foi iniciado
 */
export async function api_listarUsuariosConectados() {
  let result = null;
  try {
    const { data } = await api.get(`/system/listarUsuariosConectados`);
    result = data;
  } catch (error) {
    showMensagemErroApi(error, "listar os usuários conectados");
  }
  return result;
}

/*
 * Lista as versões do changelog (com texto, só as versões que contêm o texto)
 */
export async function api_listarChangelog(texto) {
  let result = [];
  try {
    const { data } = await api.get(`/system/listarChangelog`, {
      params: { texto },
    });
    result = data;
  } catch (error) {
    showMensagemErroApi(error, "listar as versões do changelog");
  }
  return result;
}

/*
 * Consulta o conteúdo de uma versão do changelog
 */
export async function api_consultarChangelog(arquivo) {
  let result;
  try {
    const { data } = await api.get(`/system/consultarChangelog`, {
      params: { arquivo },
    });
    result = data;
  } catch (error) {
    showMensagemErroApi(error, "consultar o changelog");
  }
  return result;
}

/*
 * Consulta a estatística da versão, comparando com a versão anterior
 */
export async function api_consultarEstatisticaVersao(versao) {
  let result;
  try {
    const { data } = await api.get(`/system/consultarEstatisticaVersao`, {
      params: { versao },
    });
    result = data;
  } catch (error) {
    showMensagemErroApi(error, "consultar a estatística da versão");
  }
  return result;
}

/*
 * Detalhe do registro de uma linha do log de alteração: dados, descrição e histórico
 */
export async function api_detalharLogAlteracao(
  idTenant,
  tabela,
  idTabela,
  idLog,
) {
  let result;
  try {
    const { data } = await api.get(`/log_alteracao/detalhar`, {
      params: {
        id_tenant: idTenant,
        tabela,
        id_tabela: idTabela,
        id_log: idLog,
      },
    });
    result = data;
  } catch (error) {
    showMensagemErroApi(error, "consultar o detalhe do registro");
  }
  return result;
}

// /*
//  * Reinicia ou pára o serviço de job
//  */
// export async function api_servicoJobAcao(acao, motivo, usuarioAutorizacao) {
//   let ret;

//   try {
//     //Grava o log da autorização
//     let logs = [];
//     logs[0] = { label: "Motivo", value: motivo };

//     const body = {
//       id_tenant: UUID_GLOBAL,
//       id_autorizacao:
//         acao == "parar"
//           ? ID_AUTORIZACAO.SYS_PARAR_SERVICO_JOB
//           : ID_AUTORIZACAO.SYS_REINICIAR_SERVICO_JOB,
//       id_usuario: usuarioAutorizacao.id,
//       model: "",
//       id_model: 0,
//       logs: logs,
//     };

//     //Reinicia ou pára o serviço de job
//     const { data } = await api.post(
//       `/job/${acao == "parar" ? "pararServico" : "reiniciarServico"}`,
//       body,
//     );
//     if (data) {
//       ret = data;
//       showMensagemSucesso(MENSAGENS_SUCESSO.OPERACAO_SUCESSO);
//     }
//   } catch (error) {
//     if (error.response?.status != 401) {
//       showMensagemErro(
//         MENSAGENS_ERRO.TENTATIVA_OPERACAO,
//         `${acao} serviço: ${error}`,
//       );
//     }
//   }
//   return ret;
// }

// /*
//  * Carrega os logs do arquivo de erro
//  */
// export async function api_loadLogsErro(tipoLog = "E", limit, dataLog, texto) {
//   let result = [];

//   try {
//     const params = new URLSearchParams();
//     if (tipoLog) params.append("tipo_log", tipoLog);
//     if (limit) params.append("limit", limit);
//     if (dataLog) params.append("data", dataLog);
//     if (texto) params.append("texto", texto);

//     const { data } = await api.get(`system/logs/erros?${params.toString()}`);
//     result = data;
//   } catch (error) {
//     if (error.response?.status != 401) {
//       showMensagemErro(MENSAGENS_ERRO.TENTATIVA_OPERACAO, `carregar logs`);
//     }
//   }
//   return result;
// }
